import script from "./ServiceDeleteModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceDeleteModal.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceDeleteModal.vue?vue&type=style&index=0&id=00f560c7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00f560c7"]])

export default __exports__